<template>
  <main class="how_it_works">
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section>
      <h1 class="how_works_title">{{ getTranslations.visitor_visitor_header_how_it_works }}</h1>
      <div class="how_sect">
        <h2>🗓️ {{ getTranslations.visitor_how_it_works_daily_games }}</h2>
        <p>{{getTranslations.visitor_how_it_works_daily_games_text}}</p>
      </div>
      <div class="how_sect">
        <h2>🥇 {{ getTranslations.visitor_how_it_works_score }}</h2>
        <p>{{getTranslations.visitor_how_it_works_score_text}}</p>
      </div>
      <div class="how_sect">
        <h2>☝  {{ getTranslations.visitor_how_it_works_game }}</h2>
        <p>{{getTranslations.visitor_how_it_works_game_text}}</p>
      </div>
      <div class="how_sect">
        <h2>🙌 {{ getTranslations.visitor_how_it_works_questions }}</h2>
        <p>{{getTranslations.visitor_how_it_works_questions_text}}</p>
      </div>
    </section>
  </main>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'howItWorks',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    /* eslint-enable */
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  methods: {
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      /* eslint-disable */
      $(window).scrollTop(0);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue